import React from 'react'
import DeliverySupportContainer from '../../../../Components/SupportMessage/DeliverySupportContainer/DeliverySupportContainer'
import Layout from '../../Layout'

const DeliverySupport = () => {
  return (
    <Layout>
        <DeliverySupportContainer/>
    </Layout>
  )
}

export default DeliverySupport